/**
 * Types for Bulk Edit Dialog
 */
export const BULK_EDIT_STEPS = {
    SELECT_DELEGATION: "select-delegation",
    EDIT_FIELDS: "edit-fields",
    CONFIRMATION: "confirmation",
    LOADING: "loading",
    RESULT: "result",
};
export const BULK_EDIT_STEPS_LIST = Object.values(BULK_EDIT_STEPS);
